export const TIMEOUT_EXEPTION = "TimeoutException" as const;
export const APP_WILL_CLOSE = "AppWillClose" as const;
export default interface CommunicationError extends Error {
  source?: string;
}
